module.exports = __webpack_public_path__ + "media/images/admin/icons/message-square-da92dd7a0359c3b9e6fbb8b09043b968.svg";